/**
 * Shared options for useJsApiLoader. Every map must use this same object so the
 * Google Maps script is loaded only once (same id, key and libraries).
 */
export const googleMapsLoaderOptions = {
    id: 'google-maps-script',
    googleMapsApiKey: process.env.RAZZLE_GOOGLE_MAPS_KEY,
    libraries: [ 'places' ],
};
